import { forwardRef } from "react";

import {
  ALERT_DEFAULTS,
  ALERT_VARIANT_CLASS_MAP,
  type TAlertProps,
} from "@/ui/components/feedback/Alert/Alert.config";
import { cn } from "@/ui/lib/utils";
import { AlertWrapper } from "./AlertWrapper";
import { AlertAsset } from "./AlertAsset";
import { AlertTitle } from "./AlertTitle";
import { AlertBody } from "./AlertBody";

export const Alert = forwardRef<HTMLDivElement, TAlertProps>(
  (
    {
      title,
      asset,
      children,
      className,
      variant = ALERT_DEFAULTS.variant,
      orientation = ALERT_DEFAULTS.orientation,
      ...props
    },
    ref,
  ) => (
    <AlertWrapper
      {...props}
      data-component="Alert"
      ref={ref}
      asset={asset}
      orientation={orientation}
      className={cn(
        ALERT_VARIANT_CLASS_MAP[variant],
        className,
      )}>
      <AlertAsset asset={asset} />
      <AlertTitle title={title} asset={asset} orientation={orientation} />
      <AlertBody asset={asset} orientation={orientation}>{ children }</AlertBody>
    </AlertWrapper>
  ),
);

Alert.displayName = "Alert";
